import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

import {Observable, of} from 'rxjs';
import {debounceTime, startWith, switchMap} from 'rxjs/operators';

import {Model, ModelKey, ModelKeyOf} from '../../model/model';
import {ModelResource} from '../../model/model-resource';
import {ObjectQueryFilterOperator, ObjectQueryParameters, ObjectQuerySortDirection} from '../../model/object-query-parameters';

@Component({
  selector: 'app-resource-auto-complete',
  templateUrl: './resource-auto-complete.component.html',
  styleUrls: ['./resource-auto-complete.component.scss']
})
export class ResourceAutoCompleteComponent<T extends Model<K>, K extends ModelKey = ModelKeyOf<T>> implements OnInit {

  @Input()
  field: string;

  @Input()
  current: T;

  private _clearable: boolean;
  @Input()
  public get clearable() { return this._clearable; }
  public set clearable(value: BooleanInput) { this._clearable = coerceBooleanProperty(value); }

  @Output()
  selected = new EventEmitter();

  @Output()
  cleared = new EventEmitter();

  resources: Observable<T[]>;

  form: UntypedFormGroup;

  private builder: UntypedFormBuilder;
  private resource: ModelResource<T, K>;

  constructor(builder: UntypedFormBuilder, resource: ModelResource<T, K>) {
    this.builder = builder;
    this.resource = resource;
    this.form = this.builder.group({
      search: [null]
    });
  }

  display(resource?: T): string | undefined {
    return resource ? resource[this.field] : undefined;
  }

  optionSelected(event: MatAutocompleteSelectedEvent): void {
    this.selected.emit(event.option.value);
  }

  optionCleared(): void {
    this.cleared.emit(true);
  }

  ngOnInit() {
    this.resources = this.form.get('search').valueChanges.pipe(
      startWith(''),
      // delay emits
      debounceTime(300),
      // use switch map so as to cancel previous subscribed events, before creating new once
      switchMap(value => {
        if (value !== '') {
          const params = new ObjectQueryParameters();
          params.addFilter('name', ObjectQueryFilterOperator.Contains, value.toString());
          params.addSort('name', ObjectQuerySortDirection.Ascending);
          return this.resource.query(params);
        } else {
          // if no value is present, return null
          return of(null);
        }
      })
    );

  }
}
